export default __webpack_public_path__ + "static/media/crudInMern1.7098ebba.png";